import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-picture",
  "use": "svgIcon-picture-usage",
  "viewBox": "0 0 2048 1792",
  "content": "<symbol viewBox=\"0 0 2048 1792\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-picture\"><path d=\"M704 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 384v448h-1408v-192l320-320 160 160 512-512zm96-704h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zm160 32v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol